export default __webpack_public_path__ + "static/media/x3.9dd42a96.png";